import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { filter, tap } from 'rxjs';

import { AppUtilityService } from '../app-utility.service';
import { UserService } from '../core/services/lmsuser.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class HomeLandingComponent implements OnInit {
  constructor(
    public userService: UserService,
    private global_utility: AppUtilityService
  ) {}

  ngOnInit(): void {
    // Navigate to role-based landing page after profile loads
    this.userService.LMSUserProfile$.pipe(
      filter(profile => profile != null),
      tap(profile => console.log("✅ User profile loaded, navigating to landing:", profile))
    ).subscribe(() => {
      this.global_utility.navigateToLanding();
    });
  }
}
